import React from "react";
import { numberFormatter } from "../../formatter";
import { useTranslation } from "react-i18next";

const th = {
  padding: "10px 14px",
  fontSize: 11,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "#888",
  background: "#fafafa",
  borderBottom: "1px solid #ebebeb",
  whiteSpace: "nowrap",
  textAlign: "left",
};

const thR = { ...th, textAlign: "right" };

const td = {
  padding: "12px 14px",
  fontSize: 13,
  color: "#222",
  borderBottom: "1px solid #f0f0f0",
  verticalAlign: "middle",
};

const tdR = { ...td, textAlign: "right" };

export default function LinesTable({ data }) {
  const { t } = useTranslation();

  const subTotal = () => data.reduce((s, l) => s + Math.abs(parseFloat(l.AmountDC) || 0), 0);
  const vat      = () => data.reduce((s, l) => s + Math.abs(parseFloat(l.VATAmount) || 0), 0);
  const total    = () => subTotal() + vat();

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
        <thead>
          <tr>
            <th style={th}>{t("SKU")}</th>
            <th style={th}>{t("Description")}</th>
            <th style={th}>{t("Unit")}</th>
            <th style={thR}>{t("Unit Price")}</th>
            <th style={thR}>{t("Quantity")}</th>
            <th style={thR}>{t("Discount")} %</th>
            <th style={thR}>{t("Net price")}</th>
            <th style={thR}>{t("Amount excl. VAT")}</th>
            <th style={thR}>{t("VAT %")}</th>
            <th style={thR}>{t("VAT amount")}</th>
            <th style={thR}>{t("Amount incl. VAT")}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => {
            const unitPrice = Math.abs(parseFloat(row.UnitPrice) || 0);
            const netPrice  = Math.abs(parseFloat(row.NetPrice)  || 0);
            const amountDC  = Math.abs(parseFloat(row.AmountDC)  || 0);
            const vatAmount = Math.abs(parseFloat(row.VATAmount) || 0);
            const discPct   = parseFloat(row.Discount) || 0;

            return (
              <tr key={row.ID}>
                <td style={{ ...td, fontWeight: 500, color: "#cc9966" }}>{row.ItemCode}</td>
                <td style={td}>{row.Description}</td>
                <td style={{ ...td, color: "#555" }}>{row.UnitDescription || row.UnitCode || "—"}</td>
                <td style={tdR}>{numberFormatter.format(unitPrice)}</td>
                <td style={tdR}>{row.Quantity}</td>
                <td style={tdR}>
                  {discPct !== 0
                    ? new Intl.NumberFormat("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        .format(discPct * 100) + "%"
                    : "—"}
                </td>
                <td style={tdR}>{numberFormatter.format(netPrice)}</td>
                <td style={tdR}>{numberFormatter.format(amountDC)}</td>
                <td style={tdR}>{row.VATPercentage ? row.VATPercentage * 100 : "0"}%</td>
                <td style={tdR}>{numberFormatter.format(vatAmount)}</td>
                <td style={{ ...tdR, fontWeight: 600 }}>{numberFormatter.format(amountDC + vatAmount)}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          {[
            [t("Sub Total"), subTotal(), false],
            [t("BTW"),       vat(),      false],
            [t("Total"),     total(),    true ],
          ].map(([label, value, bold]) => (
            <tr key={label}>
              <td colSpan={10} style={{
                padding: "8px 14px", textAlign: "right",
                fontSize: 13, color: "#555",
                borderTop: bold ? "2px solid #ebebeb" : "1px solid #f0f0f0",
              }}>
                {label}
              </td>
              <td style={{
                padding: "8px 14px", textAlign: "right",
                fontSize: bold ? 15 : 13,
                fontWeight: bold ? 700 : 500,
                color: bold ? "#222" : "#555",
                borderTop: bold ? "2px solid #ebebeb" : "1px solid #f0f0f0",
                whiteSpace: "nowrap",
              }}>
                {numberFormatter.format(value)}
              </td>
            </tr>
          ))}
        </tfoot>
      </table>
    </div>
  );
}
